const galleryBlock = (() => {
    const initBlock = (el) => {
        const galleryItems = el.querySelector('[data-gallery-items]');
        const galleryPrev = el.querySelector('[data-gallery-left]');
        const galleryNext = el.querySelector('[data-gallery-right]');
        const hasThumbs = galleryItems.children.length > 1;

        const lg = lightGallery(galleryItems, {
            container: galleryItems,
            closable: false,
            showMaximizeIcon: true,
            download: false,
            alignThumbnails: "left",
            thumbMargin: 0,
            showThumbnailWithPlayButton: true,
            exThumbImage: 'data-external-thumb-image',
            plugins: [lgThumbnail, lgVideo]
        });
        lg.openGallery(0);
        hasThumbs && galleryPrev.addEventListener('click', () => lg.goToPrevSlide());
        hasThumbs && galleryNext.addEventListener('click', () => lg.goToNextSlide());
        
        if(!hasThumbs){
            el.closest(".gallery-block").classList.add("gallery-block--hide-thumbs");
        }
    };

    return {
        initBlock
    };
})();

ControlBinders.register("[data-gallery-block-container]", el => galleryBlock.initBlock(el));